/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { SiteTwin } from '../models/site-twin';
import { SiteType } from '../models/site-type';
import { OverdueSite } from '../models/overdue-site';
@Injectable({
  providedIn: 'root',
})
class SiteTypeService extends __BaseService {
  static readonly SiteTypeSearchPath = '/api/SiteType/Search/{customerId}/{type}/{searchSize}/{pageIndex}/{filterOld}';
  static readonly SiteTypeCreatePath = '/api/SiteType/Create';
  static readonly SiteTypeGetAllPath = '/api/SiteType/GetAll';
  static readonly SiteTypeGetSitePath = '/api/SiteType/GetSite/{customerId}/{siteTypeId}/{siteUri}';
  static readonly SiteTypeGetSiteUsingCodePath = '/api/SiteType/GetSiteUsingCode/{customerId}/{siteTypeCode}/{siteUri}';
  static readonly SiteTypeGetByIdPath = '/api/SiteType/GetById';
  static readonly SiteTypeUpdatePath = '/api/SiteType/Update';
  static readonly SiteTypeDeletePath = '/api/SiteType/Delete';
  static readonly SiteTypeGetOverdueSitesPath = '/api/SiteType/GetOverdueSites/{customerId}/{siteTypeCode}/{minThresholdHours}/{maxThresholdDays}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param params The `SiteTypeService.SiteTypeSearchParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `searchSize`:
   *
   * - `pageIndex`:
   *
   * - `filterOld`:
   *
   * - `customerId`:
   *
   * - `sortOrder`:
   *
   * - `sortColumn`:
   *
   * - `search`:
   */
  SiteTypeSearchResponse(params: SiteTypeService.SiteTypeSearchParams): __Observable<__StrictHttpResponse<Array<SiteTwin>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;





    if (params.sortOrder != null) __params = __params.set('sortOrder', params.sortOrder.toString());
    if (params.sortColumn != null) __params = __params.set('sortColumn', params.sortColumn.toString());
    if (params.search != null) __params = __params.set('search', params.search.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SiteType/Search/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.type))}/${encodeURIComponent(String(params.searchSize))}/${encodeURIComponent(String(params.pageIndex))}/${encodeURIComponent(String(params.filterOld))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SiteTwin>>;
      })
    );
  }
  /**
   * @param params The `SiteTypeService.SiteTypeSearchParams` containing the following parameters:
   *
   * - `type`:
   *
   * - `searchSize`:
   *
   * - `pageIndex`:
   *
   * - `filterOld`:
   *
   * - `customerId`:
   *
   * - `sortOrder`:
   *
   * - `sortColumn`:
   *
   * - `search`:
   */
  SiteTypeSearch(params: SiteTypeService.SiteTypeSearchParams): __Observable<Array<SiteTwin>> {
    return this.SiteTypeSearchResponse(params).pipe(
      __map(_r => _r.body as Array<SiteTwin>)
    );
  }

  /**
   * @param model undefined
   */
  SiteTypeCreateResponse(model: SiteType): __Observable<__StrictHttpResponse<SiteType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'POST',
      this.rootUrl + `/api/SiteType/Create`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SiteType>;
      })
    );
  }
  /**
   * @param model undefined
   */
  SiteTypeCreate(model: SiteType): __Observable<SiteType> {
    return this.SiteTypeCreateResponse(model).pipe(
      __map(_r => _r.body as SiteType)
    );
  }

  /**
   * @param customerId undefined
   */
  SiteTypeGetAllResponse(customerId?: number): __Observable<__StrictHttpResponse<Array<SiteType>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (customerId != null) __params = __params.set('customerId', customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SiteType/GetAll`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<SiteType>>;
      })
    );
  }
  /**
   * @param customerId undefined
   */
  SiteTypeGetAll(customerId?: number): __Observable<Array<SiteType>> {
    return this.SiteTypeGetAllResponse(customerId).pipe(
      __map(_r => _r.body as Array<SiteType>)
    );
  }

  /**
   * @param params The `SiteTypeService.SiteTypeGetSiteParams` containing the following parameters:
   *
   * - `siteUri`:
   *
   * - `siteTypeId`:
   *
   * - `customerId`:
   */
  SiteTypeGetSiteResponse(params: SiteTypeService.SiteTypeGetSiteParams): __Observable<__StrictHttpResponse<SiteTwin>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SiteType/GetSite/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.siteTypeId))}/${encodeURIComponent(String(params.siteUri))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SiteTwin>;
      })
    );
  }
  /**
   * @param params The `SiteTypeService.SiteTypeGetSiteParams` containing the following parameters:
   *
   * - `siteUri`:
   *
   * - `siteTypeId`:
   *
   * - `customerId`:
   */
  SiteTypeGetSite(params: SiteTypeService.SiteTypeGetSiteParams): __Observable<SiteTwin> {
    return this.SiteTypeGetSiteResponse(params).pipe(
      __map(_r => _r.body as SiteTwin)
    );
  }

  /**
   * @param params The `SiteTypeService.SiteTypeGetSiteUsingCodeParams` containing the following parameters:
   *
   * - `siteUri`:
   *
   * - `siteTypeCode`:
   *
   * - `customerId`:
   */
  SiteTypeGetSiteUsingCodeResponse(params: SiteTypeService.SiteTypeGetSiteUsingCodeParams): __Observable<__StrictHttpResponse<SiteTwin>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;



    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SiteType/GetSiteUsingCode/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.siteTypeCode))}/${encodeURIComponent(String(params.siteUri))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SiteTwin>;
      })
    );
  }
  /**
   * @param params The `SiteTypeService.SiteTypeGetSiteUsingCodeParams` containing the following parameters:
   *
   * - `siteUri`:
   *
   * - `siteTypeCode`:
   *
   * - `customerId`:
   */
  SiteTypeGetSiteUsingCode(params: SiteTypeService.SiteTypeGetSiteUsingCodeParams): __Observable<SiteTwin> {
    return this.SiteTypeGetSiteUsingCodeResponse(params).pipe(
      __map(_r => _r.body as SiteTwin)
    );
  }

  /**
   * @param params The `SiteTypeService.SiteTypeGetByIdParams` containing the following parameters:
   *
   * - `siteTypeId`:
   *
   * - `customerId`:
   */
  SiteTypeGetByIdResponse(params: SiteTypeService.SiteTypeGetByIdParams): __Observable<__StrictHttpResponse<SiteType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (params.siteTypeId != null) __params = __params.set('siteTypeId', params.siteTypeId.toString());
    if (params.customerId != null) __params = __params.set('customerId', params.customerId.toString());
    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SiteType/GetById`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SiteType>;
      })
    );
  }
  /**
   * @param params The `SiteTypeService.SiteTypeGetByIdParams` containing the following parameters:
   *
   * - `siteTypeId`:
   *
   * - `customerId`:
   */
  SiteTypeGetById(params: SiteTypeService.SiteTypeGetByIdParams): __Observable<SiteType> {
    return this.SiteTypeGetByIdResponse(params).pipe(
      __map(_r => _r.body as SiteType)
    );
  }

  /**
   * @param model undefined
   */
  SiteTypeUpdateResponse(model: SiteType): __Observable<__StrictHttpResponse<SiteType>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    __body = model;
    let req = new HttpRequest<any>(
      'PUT',
      this.rootUrl + `/api/SiteType/Update`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<SiteType>;
      })
    );
  }
  /**
   * @param model undefined
   */
  SiteTypeUpdate(model: SiteType): __Observable<SiteType> {
    return this.SiteTypeUpdateResponse(model).pipe(
      __map(_r => _r.body as SiteType)
    );
  }

  /**
   * @param siteTypeId undefined
   */
  SiteTypeDeleteResponse(siteTypeId?: number): __Observable<__StrictHttpResponse<Blob>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;
    if (siteTypeId != null) __params = __params.set('siteTypeId', siteTypeId.toString());
    let req = new HttpRequest<any>(
      'DELETE',
      this.rootUrl + `/api/SiteType/Delete`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'blob'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Blob>;
      })
    );
  }
  /**
   * @param siteTypeId undefined
   */
  SiteTypeDelete(siteTypeId?: number): __Observable<Blob> {
    return this.SiteTypeDeleteResponse(siteTypeId).pipe(
      __map(_r => _r.body as Blob)
    );
  }

  /**
   * @param params The `SiteTypeService.SiteTypeGetOverdueSitesParams` containing the following parameters:
   *
   * - `siteTypeCode`:
   *
   * - `minThresholdHours`:
   *
   * - `maxThresholdDays`:
   *
   * - `customerId`:
   */
  SiteTypeGetOverdueSitesResponse(params: SiteTypeService.SiteTypeGetOverdueSitesParams): __Observable<__StrictHttpResponse<Array<OverdueSite>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;




    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/api/SiteType/GetOverdueSites/${encodeURIComponent(String(params.customerId))}/${encodeURIComponent(String(params.siteTypeCode))}/${encodeURIComponent(String(params.minThresholdHours))}/${encodeURIComponent(String(params.maxThresholdDays))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<OverdueSite>>;
      })
    );
  }
  /**
   * @param params The `SiteTypeService.SiteTypeGetOverdueSitesParams` containing the following parameters:
   *
   * - `siteTypeCode`:
   *
   * - `minThresholdHours`:
   *
   * - `maxThresholdDays`:
   *
   * - `customerId`:
   */
  SiteTypeGetOverdueSites(params: SiteTypeService.SiteTypeGetOverdueSitesParams): __Observable<Array<OverdueSite>> {
    return this.SiteTypeGetOverdueSitesResponse(params).pipe(
      __map(_r => _r.body as Array<OverdueSite>)
    );
  }
}

module SiteTypeService {

  /**
   * Parameters for SiteTypeSearch
   */
  export interface SiteTypeSearchParams {
    type: string;
    searchSize: number;
    pageIndex: number;
    filterOld: boolean;
    customerId: number;
    sortOrder?: null | string;
    sortColumn?: null | string;
    search?: null | string;
  }

  /**
   * Parameters for SiteTypeGetSite
   */
  export interface SiteTypeGetSiteParams {
    siteUri: string;
    siteTypeId: number;
    customerId: number;
  }

  /**
   * Parameters for SiteTypeGetSiteUsingCode
   */
  export interface SiteTypeGetSiteUsingCodeParams {
    siteUri: string;
    siteTypeCode: string;
    customerId: number;
  }

  /**
   * Parameters for SiteTypeGetById
   */
  export interface SiteTypeGetByIdParams {
    siteTypeId?: number;
    customerId?: number;
  }

  /**
   * Parameters for SiteTypeGetOverdueSites
   */
  export interface SiteTypeGetOverdueSitesParams {
    siteTypeCode: string;
    minThresholdHours: number;
    maxThresholdDays: number;
    customerId: number;
  }
}

export { SiteTypeService }
